<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Detalhes da forma de pagamento</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <div class="mb-3" v-if="!loading">
                <a class="btn btn-outline-secondary"
                    :href="getAuditUrl(payment.id, EntityEnum.Payment)" target="_blank">
                    Ir para auditoria
                    <fa icon="external-link-alt" class="muven-external-link ml-1" />
                </a>
            </div>

            <Loading page v-if="loading" />            

            <div v-if="!loading">
                <div class="muven-card muven-card-md muven-card-centered mb-3">
                    <div class="muven-card-title">
                        <p>Pagamento</p>
                    </div>
                    <div class="mb-3">
                        <label>Nome</label>
                        <p>{{payment.name}}</p>
                    </div>
                    <div>
                        <label>Status</label>
                        <p>
                            <span v-if="payment.isActive">Ativa</span>
                            <span v-if="!payment.isActive">Inativa</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import paymentService from '@/payment/services/PaymentService'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { PaymentModel } from '@/payment/models/PaymentModel'
import { EntityEnum } from '@c2b/muven-commons'
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'

export default {
    name: 'PaymentView',
    data() {
        return {
            EntityEnum,
            loading: true,
            payment: new PaymentModel(),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Formas de pagamento',
                    path: '/formas_pagamento',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],    
        }
    },
    mixins: [
        GetAuditUrl,
    ],
    filters: {
        infoOrPlaceholder,
    },
    methods: {
        async allowExportModifiedInPayment(allowExport) {
           try {
                await paymentService.updateAllowExportInPayment(this.payment.id, allowExport)
           } catch (e) {
               this.$floatingAlert.error({
                   message: e.message,
               })
           }
       },
    },
    async mounted() {
        try {
            this.payment = await paymentService.getPaymentById(this.$route.params.id)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
}
</script>
